import { OBJECT_TYPE, IMAGE_LOCAL } from '@/common/constants';
import { VideoElementObject } from '@/common/models/element';
import { cloneDeep } from 'lodash';
import { isEmpty } from './util';

// Ensure that any element use this function should define crossOrigin: 'anonymous'
// this will verify cors header
// the crossOrigin: 'anonymous' is required to load image to canvas
export const modifyUrl = originalUrl => {
  if (!originalUrl) return '';
  if (originalUrl.includes('data:image') || originalUrl.startsWith('blob:')) return originalUrl;
  // The query ?pp-cors added here to separate the url from the original url 
  // in case of browser cache the no-cors version of the image causing cors issue
  return `${originalUrl.split('?')[0]}?pp-cors`;
};

export const getOriginalUrl = originalUrl => {
  if (!originalUrl) return '';
  if (originalUrl.includes('data:image') || originalUrl.startsWith('blob:')) return originalUrl;
  return `${originalUrl.split('?')[0]}`;
};

export const convertToHttp = url => {
  const encodingUrlPrefix = 'https://fms.production.s3.amazonaws.com';
  if (!url.includes(encodingUrlPrefix)) return url;

  return 'http' + url.substring(5);
};

export const removeMediaContentWhenCreateThumbnail = objects => {
  const clonedObjects = !isEmpty(objects) ? cloneDeep(objects) : [];

  clonedObjects.forEach((o, idx) => {
    if (!o) return;

    // if it's a video => convert it to Video Object
    if (o.type === OBJECT_TYPE.VIDEO) {
      const newObject = new VideoElementObject(o);
      newObject.imageUrl = IMAGE_LOCAL.PLACE_HOLDER;
      newObject.imageId = null;
      newObject.thumbnailUrl = null;
      newObject.customThumbnailUrl = null;
      newObject.duration = null;
      newObject.endTime = null;
      newObject.volume = 0;
      newObject.zoomLevel = null;
      newObject.hasImage = false;
      clonedObjects[idx] = newObject;
      return;
    }
    if (o.type === OBJECT_TYPE.IMAGE || o.type === OBJECT_TYPE.PORTRAIT_IMAGE) {
      o.imageUrl = IMAGE_LOCAL.PLACE_HOLDER;
      o.hasImage = false;
      o.zoomLevel = null;
      o.originalUrl = '';
    }
  });

  return clonedObjects;
};
